module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/9ff2f106c8b5d0f7e53714767c7ac869.png";